<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Settings</v-card-title>
          <v-card-text>
            <v-switch
              label="Dark Mode"
              v-model="darkModeSetting"
              @change="toggleDark"
            ></v-switch>
            <v-btn @click="updateApp" rounded color="primary">Update App</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  created() {
    this.darkModeSetting = this.darkMode;
  },
  data() {
    return {
      darkModeSetting: false
    };
  },
  computed: {
    ...mapState(["user", "darkMode"])
  },
  methods: {
    ...mapMutations(["setUser", "toggleDarkMode"]),
    toggleDark() {
      this.toggleDarkMode();
      if (this.darkMode == true) {
        return (this.$vuetify.theme.dark = true);
      } else {
        return (this.$vuetify.theme.dark = false);
      }
    },
    updateApp() {
      location.reload(true);
    }
  }
};
</script>

<style lang="scss" scoped></style>
